import React from 'react';
import {Trans} from 'react-i18next';
import classnames from 'classnames';
import ConfirmDialog from '../../../../components/dialogs/ConfirmDialog';
import InfoDialog from '../../../../components/dialogs/InfoDialog';
import _get from 'lodash/get';

export default function PublishBtn({
  dirty,
  handlePublish,
  actionBtns,
  isSubmitting,
}) {
  const enablePublish = _get(actionBtns, 'enable_publish', false);
  const status = _get(actionBtns, 'status');
  if (dirty) {
    return (
      <>
        <InfoDialog
          trigger={'click'}
          placement={'bottom'}
          description={
            <Trans i18nKey="p.s.uiconfiguration.publish.online.desc">
              You need save all unsaved changes, please save your page first.
            </Trans>
          }
        >
          <div
            style={{
              display: 'inline-block',
              cursor: 'not-allowed',
            }}
          >
            <button
              disabled
              style={{pointerEvents: 'none'}}
              className={classnames({
                btn: true,
                'btn-primary': true,
              })}
            >
              <Trans i18nKey="p.s.uiconfiguration.publish.online">
                Publish to Online
              </Trans>
            </button>
          </div>
        </InfoDialog>
      </>
    );
  }

  return (
    <ConfirmDialog
      confirmCallback={handlePublish}
      placement={'bottom'}
      title={
        <>
          <Trans i18nKey="p.s.uiconfiguration.publish.online.title">
            All UI configurations in the four tabs will be published. This may
            take up to 30 minutes.
          </Trans>
          <Trans i18nKey="p.s.uiconfiguration.publish.online.note">
            (Note: The App Preview QR Code will be updated as well.)
          </Trans>
          <br />
          <br />
          <Trans i18nKey="c.dialog.sure.continue">
            Are you sure to continue?
          </Trans>
        </>
      }
    >
      <button
        type="button"
        disabled={!enablePublish || isSubmitting}
        className={classnames({
          btn: true,
          'btn-primary': true,
          'kt-spinner': true,
          'kt-spinner-v2': true,
          'kt-spinner--center': true,
          'kt-spinner--sm': true,
          'kt-spinner--warning': status === 'Publishing',
        })}
      >
        <Trans i18nKey="p.s.uiconfiguration.publish.online">
          Publish to Online
        </Trans>
      </button>
    </ConfirmDialog>
  );
}
